import ImageSlider from 'components/BuildingRotate/ImageSlider';
import { useState } from 'react';
import './style.scss';
import { FilterLayout } from './components/FilterLayout/FilterLayout';

const MatBangTangPage = () => {
  const [activeFloor, setActiveFloor] = useState(null);

  return (
    <div className="mat-bang-tang-page">
      <ImageSlider activeFloor={activeFloor} />
      <div className="tien-ich-filter">
        <FilterLayout
          activeFloor={activeFloor}
          setActiveFloor={setActiveFloor}
        />
      </div>
    </div>
  );
};

export default MatBangTangPage;
